import { AnswerSelectContainerProps } from '../config';
import { FC } from 'react';
import { IAnswerModel } from '../../../../state/stores/Question/AnswerModel';
import { SnapshotOrInstance } from 'mobx-state-tree';
import { getMetaValue, unwrapMeta } from '../../utils';
import { observer } from 'mobx-react';
import { useStores } from '../../../../hooks/useStores';

const _ContainChooseDate: FC<AnswerSelectContainerProps> = ({
  question,
  onNext,
  children,
}) => {

  const { question: qstore, language, treeNav } = useStores();
  const labels = language?.translate.MOBILE?.ASSISTANCE?.WPO;

  const refetchQuestion = () => {
    if (qstore.isReady(question._id) && treeNav.choices.pending) {
      // user intention is to peek at one section which is not loaded
      // so we fetch question again with survey responses indicating that empty section
      // then append new answers for that section to question store
      qstore.fetchQuestionWithCurrentSurveyResponses(question._id, 'appendAnswers');
    }
  };

  const onPressSection = (answer: SnapshotOrInstance<IAnswerModel>) => {
    const option = getMetaValue('option', answer);
    if (!option) {
      refetchQuestion();
    }
    treeNav.choices.setPending({
      questionId: question._id,
      questionKey: question.key,
      answers: [{
        id: answer._id,
        key: answer.key,
        meta: answer.meta,
      }],
    });
    if (option) {
      onNext?.();
    }
  };

  const isReady = qstore.isReady(question._id);

  // answers depend on language
  // if language is different from current answers then we must be in a loading state
  let languageChange = false;
  if (!isReady) {
    const answerWithLanguage = question.answers?.find(a => a.meta?.some(m => m.key === 'language'));
    console.log(answerWithLanguage);
    const { language: previousLanguage }  = unwrapMeta(['language'], answerWithLanguage);
    const languageQuestion = treeNav.choices.finalised.find(r => r.questionKey === 'language');
    const languageId = languageQuestion?.answers?.[0]?.key;
    console.log(previousLanguage, languageId);
    if (previousLanguage && previousLanguage !== languageId) {
      // user has selected a different langauge.
      languageChange = true;
    }
  }

  // set loading=true when loading the entire set of sections.
  // individual sections can be loading separately - this is handled in presentation
  // languageChange is another situation of 'totally' loading state
  const sections = question.answers
    ?.filter(answer => answer.meta?.some(meta => meta.key === 'section') && !answer.meta?.some(meta => meta.key === 'option')) || [];
  const loading = !isReady && (!sections?.length || languageChange);

  return children({
    answers: question.answers,
    questionId: question._id,
    questionKey: question.key,
    onPress: onPressSection,
    loading,
    labels: {
      NO_CONTENT: labels?.NO_CONTENT,
    }
  });

};

export const ContainChooseDate = observer(_ContainChooseDate);
